<template></template>

<script>
export default {
  props: {
    msgid: String,
    msgstr: String
  },
  created: function () {
    var self = this
    self.$parent.$emit('translation-custom', self.msgid, self.msgstr)
  }
}
</script>



// WEBPACK FOOTER //
// Literal.vue?259e0d6e